import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import Button from '@precis-digital/kurama/Button';
import Divider from '@precis-digital/kurama/Divider';
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { styled } from '@precis-digital/kurama/utils';
import alvieLogoFull from 'public/assets/images/alvie_logo_full.svg';
import manWithPhone from 'public/assets/images/man_w_phone.png';
import ThemedImage from 'shared/components/Themed/Image';
import { StyledGridButtonsContainer, StyledGridErrorCodeMessageContainer, StyledGridPageContainer, StyledGridRightSideContainer, StyledGridTextContainer, StyledGridTopSectionContainer } from './styles';
import logger from 'shared/logger';
import { formatPageMetaTitle } from 'shared/utils/stringFormatter';
import { APP_ROUTES } from 'shared/routes';
import { useChangePath } from 'shared/components/Router';
import Head from 'next/head';
import { useTranslation } from 'shared/translations';
const log = logger().child({
  namespace: 'error'
});
interface Error {
  message: string;
  traceId?: string;
}
const InvalidClient = t0 => {
  const $ = _c(27);
  const {
    error,
    hasDashboardFrame: t1
  } = t0;
  const hasDashboardFrame = t1 === undefined ? true : t1;
  log.error(error.message);
  const {
    changePath
  } = useChangePath();
  const {
    t
  } = useTranslation("common");
  let t2;
  if ($[0] !== changePath) {
    t2 = () => {
      changePath(APP_ROUTES.workspace.listPage);
    };
    $[0] = changePath;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleViewAllWorkspacesClick = t2;
  let t3;
  if ($[2] !== changePath) {
    t3 = () => {
      changePath(APP_ROUTES.home.basePage);
    };
    $[2] = changePath;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleLogoClick = t3;
  let t4;
  if ($[4] !== t) {
    t4 = formatPageMetaTitle({
      pageTitle: t("metaTitle.unknownWorkspace")
    });
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <Head><title>{t4}</title></Head>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <StyledGridImageContainer><ThemedImage src={manWithPhone} alt="Man with phone" priority={true} /></StyledGridImageContainer>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleLogoClick || $[10] !== hasDashboardFrame) {
    t7 = !hasDashboardFrame && <StyledGridLogoContainer onClick={handleLogoClick}><ThemedImage src={alvieLogoFull} alt="Alvie Logo Icon Blue" width={128} height={64} priority={true} /></StyledGridLogoContainer>;
    $[9] = handleLogoClick;
    $[10] = hasDashboardFrame;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <StyledGridTextContainer><Typography variant="h2">Oops, we could not find this workspace.</Typography><Typography variant="body2">Either the workspace you requested does not exist or you do not have access. If this is a mistake, please reach out to your workspace admin.</Typography></StyledGridTextContainer>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== handleViewAllWorkspacesClick) {
    t9 = <StyledGridRightSideContainer>{t8}<StyledGridButtonsContainer><Button variant="filled" onClick={handleViewAllWorkspacesClick}>View all workspaces</Button></StyledGridButtonsContainer></StyledGridRightSideContainer>;
    $[13] = handleViewAllWorkspacesClick;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== hasDashboardFrame || $[16] !== t7 || $[17] !== t9) {
    t10 = <StyledGridTopSectionContainer hasDashboardFrame={hasDashboardFrame}>{t6}{t7}{t9}</StyledGridTopSectionContainer>;
    $[15] = hasDashboardFrame;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <StyledGridErrorCodeMessageContainer><Typography variant="h4">403</Typography><Typography variant="body2">- That's just an error which means that you don't have access to what you were looking for.</Typography></StyledGridErrorCodeMessageContainer>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== hasDashboardFrame || $[22] !== t10) {
    t13 = <StyledGridPageContainer hasDashboardFrame={hasDashboardFrame}>{t10}{t11}{t12}</StyledGridPageContainer>;
    $[21] = hasDashboardFrame;
    $[22] = t10;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t5) {
    t14 = <>{t5}{t13}</>;
    $[24] = t13;
    $[25] = t5;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
const StyledGridImageContainer = styled(Grid)(() => ({
  width: '40%',
  marginLeft: '160px',
  marginRight: '-100px'
}));
const StyledGridLogoContainer = styled(Grid)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  display: 'flex',
  gap: '26px',
  padding: '14px',
  ':hover': {
    cursor: 'pointer',
    backgroundColor: theme.tokens.background.main.pressed
  },
  borderRadius: '16px'
}));
export default InvalidClient;